import { Box, Typography, useTheme } from "@mui/material";
import { Trans } from "react-i18next";
import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	getResourcePath,
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type DashboardCardValueProps = {
	dashboardData: DashboardType;
	isMissingValueWithItems: boolean;
};

export const DashboardCardValue = ({
	dashboardData,
	isMissingValueWithItems,
}: DashboardCardValueProps) => {
	const { t } = useResource();
	const { palette } = useTheme();

	if (isMissingValueWithItems) {
		return (
			<Typography
				component="div"
				fontSize={14}
				fontWeight={400}
				lineHeight="20px"
				textAlign="center"
				color={palette.darkmodeText.white}
				px={4}
				zIndex={1}
			>
				<Trans
					i18nKey={getResourcePath(Resources.Dashboard.TitleCard.zeroValue)}
					count={dashboardData.itemCountWithoutValue}
					components={{
						b: <Box component="span" fontWeight={700} />,
					}}
				/>
			</Typography>
		);
	}

	const currencyLabel = t(
		Resources.PortfolioDetail.SharedLabels.Currency[
			dashboardData.currency as CurrencyEnum
		],
	);

	return (
		<Typography
			fontSize={32}
			fontWeight={700}
			color={palette.darkmodeText.white}
			zIndex={1}
			lineHeight="40px"
		>
			{moneyFormatter(Math.round(dashboardData.value ?? 0), currencyLabel)}
		</Typography>
	);
};
